
import { defineComponent } from 'vue'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Menu from 'primevue/contextmenu'
import Dialog from 'primevue/dialog'
import qbeSimpleTableDescriptor from './QBESmartTableDescriptor.json'
import { formatDate, getLocale } from '@/helpers/commons/localeHelper'
import { formatNumber } from '@/helpers/commons/qbeHelpers'

export default defineComponent({
    name: 'qbe-simple-table',
    props: { previewData: { type: Object, required: true }, query: { type: Object, required: true }, pagination: { type: Object } },
    components: { Column, DataTable, Menu, Dialog },
    emits: ['removeFieldFromQuery', 'orderChanged', 'fieldHidden', 'fieldGrouped', 'fieldAggregated', 'aliasChanged', 'entityDropped', 'reordered', 'pageChanged', 'openFilterDialog'],
    data() {
        return {
            qbeSimpleTableDescriptor,
            aliasDialogVisible: false,
            alias: '',
            menuButtons: [] as any,
            lazyParams: {} as any,
            selectedField: {} as any,
            first: 0
        }
    },
    computed: {
        filteredVisibleFields(): any {
            const newArr = this.query?.fields?.filter((field) => field.visible === true && field.inUse === true)
            return newArr
        }
    },
    watch: {
        previewData() {
            this.loadPagination()
        }
    },
    created() {
        this.loadPagination()
    },
    methods: {
        showMenu(event, col) {
            this.createMenuItems(col)
            // eslint-disable-next-line
            // @ts-ignore
            this.$refs.smartTableMenu.toggle(event)
        },
        createMenuItems(field) {
            this.menuButtons = []
            let visibleIcon = field.visible ? 'fas fa-check' : 'fas fa-times'
            let groupIcon = field.group ? 'fas fa-check' : 'fas fa-times'
            this.menuButtons.push(
                { key: '1', label: this.$t('qbe.detailView.smartViewMenu.showField'), icon: visibleIcon, command: () => this.hideField(field) },
                { key: '2', label: this.$t('qbe.detailView.smartViewMenu.group'), icon: groupIcon, visible: field.iconCls == 'attribute' || (field.iconCls == 'calculation' && field.attributes.formState.nature.toLowerCase() == 'attribute'), command: () => this.groupField(field) },
                {
                    key: '3',
                    label: this.$t('qbe.detailView.smartViewMenu.aggregation.title') + `: ${field.funct}`,
                    visible: field.iconCls == 'measure' || (field.iconCls == 'calculation' && field.attributes.formState.nature.toLowerCase() == 'measure'),
                    items: [
                        { label: this.$t('qbe.detailView.smartViewMenu.aggregation.sum'), command: () => this.applyAggregation(field, 'SUM') },
                        { label: this.$t('qbe.detailView.smartViewMenu.aggregation.min'), command: () => this.applyAggregation(field, 'MIN') },
                        { label: this.$t('qbe.detailView.smartViewMenu.aggregation.max'), command: () => this.applyAggregation(field, 'MAX') },
                        { label: this.$t('qbe.detailView.smartViewMenu.aggregation.avg'), command: () => this.applyAggregation(field, 'AVG') },
                        { label: this.$t('qbe.detailView.smartViewMenu.aggregation.count'), command: () => this.applyAggregation(field, 'COUNT') },
                        { label: this.$t('qbe.detailView.smartViewMenu.aggregation.distinct'), command: () => this.applyAggregation(field, 'COUNT_DISTINCT') }
                    ]
                },
                { key: '4', label: this.$t('qbe.detailView.smartViewMenu.rename'), icon: 'fas fa-tag', command: () => this.showChangeAliasDialog(field) }
            )
        },
        changeOrder(field) {
            field.order === 'ASC' ? (field.order = 'DESC') : (field.order = 'ASC')
            this.$emit('orderChanged')
        },
        hideField(field) {
            field.visible = !field.visible
            this.$emit('fieldHidden')
        },
        groupField(field) {
            field.group = !field.group
            this.$emit('fieldGrouped')
        },
        applyAggregation(field, value) {
            field.funct = value
            this.$emit('fieldAggregated')
        },
        showChangeAliasDialog(field) {
            this.selectedField = field
            this.alias = JSON.parse(JSON.stringify(field.alias))
            this.aliasDialogVisible = true
        },
        changeAlias() {
            this.selectedField.alias = this.alias
            this.aliasDialogVisible = false
            this.$emit('aliasChanged', this.selectedField)
        },
        onDrop(event) {
            var data = JSON.parse(event.dataTransfer.getData('text/plain'))
            this.$emit('entityDropped', data)
        },
        loadPagination() {
            this.lazyParams = this.pagination as any
            this.first = this.pagination?.start
        },
        onPage(event: any) {
            this.lazyParams = { paginationStart: event.first, paginationLimit: event.rows, paginationEnd: event.first + event.rows, size: this.lazyParams.size }
            this.$emit('pageChanged', this.lazyParams)
        },
        fieldHasFilters(field: any) {
            for (let i = 0; i < this.query.filters.length; i++) {
                const tempFilter = this.query.filters[i]
                if (tempFilter.leftOperandValue === field.id) {
                    return true
                }
            }

            return false
        },
        openFiltersDialog(field: any) {
            this.$emit('openFilterDialog', field)
        },
        getFormattedNumber(column: any, number: number) {
            const configuration = formatNumber(column)
            let locale = getLocale()
            locale = locale ? locale.replaceAll('_', '-') : 'en-US'
            if (!configuration) return number
            const formattedNumber = Intl.NumberFormat(locale, { minimumFractionDigits: configuration.minFractionDigits, maximumFractionDigits: configuration.maxFractionDigits, useGrouping: configuration.useGrouping }).format(number)
            return configuration.currency + formattedNumber
        },
        getFormattedDate(date: any, output: any, input: any) {
            if (!date) return null
            return formatDate(date, output, input)
        }
    }
})
